import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl } from "store/baseUrls";
import { xApiKey } from "store/apiKeys";
import type { RootState } from "..";
import type { Result } from "store/api.type";
import { Track } from "store/track/track.model";
import type { Playlist } from "./playlist.model";

export const playlistApi = createApi({
  reducerPath: "playlistApi",
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      headers.set("Accept", "application/json");
      headers.set("X-Api-Key", xApiKey);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getForeignPlaylists: builder.query<
      Playlist[],
      { offset?: number; limit?: number }
    >({
      query: ({ offset = 0, limit = 20 }) =>
        `/v1/Playlist?where[0][type]=isFalse&where[0][attribute]=persian&offset=${offset}&maxSize=${limit}`,
      transformResponse: (data: Result<Playlist>) => data.list,
    }),
    getIranianPlaylists: builder.query<
      Playlist[],
      { offset?: number; limit?: number }
    >({
      query: ({ offset = 0, limit = 20 }) =>
        `/v1/Playlist?where[0][type]=isTrue&where[0][attribute]=persian&offset=${offset}&maxSize=${limit}`,
      transformResponse: (data: Result<Playlist>) => data.list,
    }),
    getPlaylist: builder.query<Playlist, { playlistId: string }>({
      query: ({ playlistId }) => `/v1/Playlist/${playlistId}`,
    }),
    getPlaylistTracks: builder.query<Track[], { playlistId: string }>({
      query: ({ playlistId }) => `/v1/Playlist/${playlistId}/tracks`,
      transformResponse: (data: Result<Track>) => data.list,
    }),
  }),
});

export const {
  useGetForeignPlaylistsQuery,
  useGetIranianPlaylistsQuery,
  useGetPlaylistQuery,
  useGetPlaylistTracksQuery,
  util: playlistApiUtil,
} = playlistApi;
